export default __webpack_public_path__ + "static/media/zewdie.aea26ccd.jpg";